import React, { useState } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
import { AccaRouteUrl, V2Route } from '@utils/routeUtil';
import { AccaModalType } from '@domain/constant/acca/AccaModalType';
import AccaModal from '@components/acca/test/modals';
import Icon from '@common/assets';
import Colors from '@domain/constant/colors';
import Link from 'next/link';
import Image from '@common/image';

const cx = classnames.bind(styles);

const Introduce = () => {
  const [modalState, setModalState] = useState<AccaModalType>(null);
  const handleResultExampleClick = () => {
    window.open(AccaRouteUrl.ACCA_SAMPLE_RESULT, '_blank', 'menubar=no, toolbar=no, width=1040');
  };

  return (
    <div className={cx('introduceArea')}>
      <Image src={'/img/v2/components/acca/test/imgAcca.png'} alt={''} width={344} height={256} />

      <div className={cx('descArea')}>
        <div>
          <ul className={cx('listArea')}>
            <li className={cx('listItem')}>
              <Icon name="matchingPersonGreen" width={40} height={40} />
              <span>
                한 번 응시하면 <em className={cx('em')}>750여 개 기업 취업 준비</em> 완료
              </span>
            </li>
            <li className={cx('listItem')}>
              <Icon name="acca" width={40} height={40} />
              <span>
                나만의 <em className={cx('em')}>자기소개서 작성 가이드, 면접 가이드</em> 제공
              </span>
            </li>
            <li className={cx('listItem')}>
              <Icon name="invitationUser" width={40} height={40} />
              <span>
                인사 담당자에게 <em className={cx('em')}>제안받는 매칭 대상자</em>로 선정
              </span>
            </li>
          </ul>

          <div className={cx('descWrap')}>
            <div className={cx('desc')}>
              <Icon name="timeLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
              <span className={cx('text')}>80분 (이어하기 가능)</span>
            </div>
            <div className={cx('desc')}>
              <Icon name="contentsLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
              <span className={cx('text')}>질의응답, 게임, 영상면접</span>
            </div>
          </div>
        </div>

        <div className={cx('btnArea')}>
          <Link href={AccaRouteUrl.ACCA_INTRODUCE} legacyBehavior>
            <a className={cx('btn')}>
              소개
              <Icon name="arrowRightLight" width={24} height={24} />
            </a>
          </Link>
          <button className={cx('btn')} onClick={handleResultExampleClick}>
            결과표 예시
            <Icon name="arrowRightLight" width={24} height={24} />
          </button>
          <Link href={V2Route.getAccaGuidePage()} legacyBehavior>
            <a className={cx('btn')}>
              응시 가이드
              <Icon name="arrowRightLight" width={24} height={24} />
            </a>
          </Link>
        </div>
      </div>
      <AccaModal modalState={modalState} setModalState={setModalState} />
    </div>
  );
};

export default Introduce;
